import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

export const convertUTCtoLocal = (dateString: string): string => {
  const date = new Date(dateString);
  const adjustedDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60 * 1000
  );
  return adjustedDate.toLocaleString("en-US", { hour12: false });
};

export const formatDateStr = (
  date: Date | string,
  dateFormat?: string,
  isLocalDateTime?: boolean
): string => {
  if (isLocalDateTime) {
    return dayjs(date).format(dateFormat ? dateFormat : "MM/DD/YYYY");
  }
  dayjs.extend(utc);
  return dayjs.utc(date).format(dateFormat ? dateFormat : "MM/DD/YYYY");
};
